<template>
  <div class="container page">
    <van-nav-bar :title="$t('mine.gamerecord')" class="nav-bar" :border="false">
      <template #left>
        <van-icon name="arrow-left" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty v-if="list.length === 0" :description="$t('withdraw.empty_data')" />
        <div v-else class="game-record-card" v-for="item in list" :key="item.id">
          <div class="gr-header">
            <span class="gr-id">{{ item.expect }}</span>
            <span class="gr-name">{{ item.name }}</span>
          </div>
          <div class="gr-result" v-if="item.opencode && item.opencode.length >= 3">
            <div class="gr-dice">
              <img v-for="(n, di) in item.opencode" :key="di" :src="diceImg(n)" alt="" />
            </div>
            <div class="gr-result-text">
              <span>{{ getSum(item.opencode) }}</span>
              <span>{{ getSizeLabel(item.opencode) }}</span>
              <span>{{ getDoubleLabel(item.opencode) }}</span>
            </div>
          </div>
          <div class="gr-status-row">
            <span class="gr-status" :class="{ pending: item.status !== 1 }">{{ getTaskStatus(item) }}</span>
            <span class="gr-amount">{{ $t('game_record.bet_amount') }}: {{ formatBetMoney(item.money) }}</span>
          </div>
          <div class="gr-bet-row" v-if="getBetContent(item)">
            <span class="gr-bet-label">{{ $t('game_record.bet_content') }}:</span>
            <span class="gr-bet-value">{{ getBetContent(item) }}</span>
          </div>
          <div class="gr-time">{{ $t('reservation.order_time') }}: {{ item.create_time }}</div>
          <div class="gr-time">{{ $t('reservation.settle_time') }}: {{ item.update_time }}</div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { getBetContent, formatBetMoney } from '@/utils/gameBet'

export default {
  name: 'LotteryRecord',
  data() {
    return {
      isLoading: false,
      list: []
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    onRefresh() {
      this.getUserGameList()
    },
    getUserGameList() {
      this.isLoading = true
      this.$http({ method: 'get', url: 'user_get_game_list' }).then(res => {
        this.isLoading = false
        if (res.code === 200) {
          const raw = res.data || []
          this.list = Array.isArray(raw) ? raw : Object.values(raw)
        } else if (res.code === 401) {
          this.$toast(res.msg)
        }
      }).catch(() => {
        this.isLoading = false
      })
    },
    diceImg(num) {
      return `/img/lottery/shaizi/${num}.png`
    },
    getSum(opencode) {
      if (!opencode || opencode.length < 3) return ''
      return opencode[0] + opencode[1] + opencode[2]
    },
    getSizeLabel(opencode) {
      const sum = this.getSum(opencode)
      return sum >= 11 && sum <= 18 ? '甲' : '乙'
    },
    getDoubleLabel(opencode) {
      const sum = this.getSum(opencode)
      return sum % 2 === 0 ? '丁' : '丙'
    },
    getBetContent,
    formatBetMoney,
    getTaskStatus(item) {
      if (item.status === 1) return this.$t('game_record.status_completed')
      return item.status_text || this.$t('my.audit_waiting')
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' })
    } else {
      this.getUserGameList()
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/base.css';
</style>
